// extracted by mini-css-extract-plugin
export default {"main":"tv_favorites_main__EnQEW","title":"tv_favorites_title__OHY0T","items":"tv_favorites_items__SNfm9","item":"tv_favorites_item__mbCU1"};